import _ from 'lodash';
import CMSModel from '@/visa-application/models/CMSModel';

export default class LoginCMSModel implements CMSModel {
  title = '';
  description = '';
  from_title = '';
  email = '';
  password = '';
  forget_password = '';
  login_button = '';
  navbar_login_button = '';
  navbar_register_button = '';
  logout_button = '';
  my_application_button = '';
  login_max_error_title = '';
  login_max_error_content = '';

  map(obj: any): any {
    this.title = _.get(obj, 'translation[0].title', '');
    this.description = _.get(obj, 'translation[0].description', '');
    this.from_title = _.get(obj, 'translation[0].from_title', '');
    this.email = _.get(obj, 'translation[0].email', '');
    this.password = _.get(obj, 'translation[0].password', '');
    this.forget_password = _.get(obj, 'translation[0].forget_password', '');
    this.login_button = _.get(obj, 'translation[0].login_button', '');
    this.navbar_login_button = _.get(obj, 'translation[0].navbar_login_button', '');
    this.navbar_register_button = _.get(obj, 'translation[0].navbar_register_button', '');
    this.logout_button = _.get(obj, 'translation[0].logout_button', '');
    this.my_application_button = _.get(obj, 'translation[0].my_application_button', '');
    this.login_max_error_title = _.get(obj, 'translation[0].login_max_error_title', '');
    this.login_max_error_content = _.get(obj, 'translation[0].login_max_error_content', '');
  }
}
